module.exports = __webpack_public_path__ + "static/media/cross-extension-panel.c9e3795a.png";